import React from 'react'
import { Footer, Heading, Main } from '.'

export const App = ({ className, style }) => {
  return <div className='app-grid'>
    <Heading />
    <Main />
    <Footer />
  </div>
}
